import Modal from 'bee-modal'

export default Modal
